import React, { ReactElement } from 'react';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import defaultLocales from 'globals/locales/default';
import FsButton from 'ui-elements/buttons/FsButton';

export const getButtons = (isUpSm: boolean): Array<ReactElement> => [
  <FsButton
    color="primary"
    key={1}
    href="https://friendlyscore.com/developers/"
    startIcon={<DescriptionOutlinedIcon />}
    whiteSpace
  >
    {isUpSm ? defaultLocales.readDocs : defaultLocales.docs}
  </FsButton>,
];
